module.exports = __webpack_public_path__ + "media/images/certificates/ssl-095d14acc22800b11e8e4216f6c63ad2.png";